import { css } from '@emotion/core'
import { Alert, Button, HFlow, Icon, Text, VFlow } from 'bold-ui'
import CheckPermission from 'components/auth/CheckPermission'
import { Box } from 'components/Box'
import { useFlags } from 'config/useFlagsContext'
import { useCertificadoRndsQuery } from 'graphql/hooks.generated'
import { TipoRegistroRndsEnum } from 'graphql/types.generated'
import React, { useState } from 'react'
import Permissions from 'types/Permissions'

import { RndsErrosImpressaoModal } from './components/RndsErrosImpressaoModal'
import EnviosRndsAccordion from './EnviosRndsAccordion'
import RndsTitle from './RndsTitle'
import { StatusUltimoEnvioRnds } from './StatusUltimoEnvioRnds'

export function RndsView() {
  const {
    data: { conexao, configuracaoCertificadoHabilitado },
  } = useCertificadoRndsQuery()
  const { ENVIO_RAC_ENABLED, ENVIO_RPM_ENABLED, ENVIO_VACINA_ENABLED } = useFlags()

  const [openErrosImpressaoModal, setOpenErrosImpressaoModal] = useState(false)

  return (
    <CheckPermission permission={Permissions.configuracaoMunicipal.visualizarEnvioRnds}>
      <Box>
        <VFlow>
          <RndsTitle />
          {configuracaoCertificadoHabilitado?.rndsHabilitado ? (
            <VFlow>
              <HFlow alignItems='center' justifyContent='space-between'>
                {conexao?.internet?.habilitado ? (
                  <StatusUltimoEnvioRnds />
                ) : (
                  <Alert type='warning' inline>
                    A conexão com a internet está desabilitada no PEC. Entre em contato com o Administrador da
                    Instalação.
                  </Alert>
                )}
                <>
                  <RndsErrosImpressaoModal
                    open={openErrosImpressaoModal}
                    onClose={() => setOpenErrosImpressaoModal(false)}
                  />
                  <Button kind='primary' onClick={() => setOpenErrosImpressaoModal(true)}>
                    <Icon
                      icon='fileWithItemsOutline'
                      style={css`
                        margin-right: 0.5rem;
                      `}
                    />
                    Gerar relatório de erros
                  </Button>
                </>
              </HFlow>
              {ENVIO_VACINA_ENABLED && (
                <EnviosRndsAccordion
                  title='Registro de Imunobiológico Administrado em:  Campanha (RIA-C) ou  Rotina (RIA-R)'
                  tipoRegistro={TipoRegistroRndsEnum.VACINA}
                />
              )}
              {ENVIO_RAC_ENABLED && (
                <EnviosRndsAccordion
                  title='Registro de Atendimento Clínico (RAC)'
                  tipoRegistro={TipoRegistroRndsEnum.ATENDIMENTO_INDIVIDUAL}
                />
              )}
              {ENVIO_RPM_ENABLED && (
                <EnviosRndsAccordion
                  title='Registro de Preescrição de Medicamentos (RPM)'
                  tipoRegistro={TipoRegistroRndsEnum.PRESCRICAO_MEDICAMENTO}
                />
              )}
            </VFlow>
          ) : (
            <Text fontStyle='italic'>Certificado não configurado. Não há registros a serem exibidos.</Text>
          )}
        </VFlow>
      </Box>
    </CheckPermission>
  )
}
